import { h } from "@stencil/core";
import { basicModel1, model2 } from "./models";
import { renderShowcaseProperties } from "../utils";
const state = {};
const render = () => (h("div", { class: "segmented-control-test-main-wrapper" }, h("ch-segmented-control-render", { model: state.model })));
const showcaseRenderProperties = [
    {
        caption: "Models",
        properties: [
            {
                id: "model",
                accessibleName: "Model",
                type: "enum",
                values: [
                    { caption: "Model 1", value: basicModel1 },
                    { caption: "Model 2", value: model2 }
                ],
                value: basicModel1
            }
        ]
    }
];
const showcasePropertiesInfo = [
    {
        name: "class",
        fixed: true,
        value: "segmented-control",
        type: "string"
    },
    { name: "model", fixed: true, value: "controlUIModel", type: "function" }
];
export const segmentedControlShowcaseStory = {
    properties: showcaseRenderProperties,
    markupWithUIModel: {
        uiModel: () => state.model,
        uiModelType: "SegmentedControlModel",
        render: {
            react: () => `<ChSegmentedControlRender${renderShowcaseProperties(state, "react", showcasePropertiesInfo)}
      >
      </ChSegmentedControlRender>`,
            stencil: () => `<ch-segmented-control-render${renderShowcaseProperties(state, "stencil", showcasePropertiesInfo)}
        >
        </ch-segmented-control-render>`
        }
    },
    render: render,
    state: state
};
